import { ENVIRONMENTS } from "../constants";

export const getEnvironment = () => {
    const env = process.env.NEXT_PUBLIC_APP_ENV;

    switch (env) {
        case ENVIRONMENTS.PRODUCTION:
            return ENVIRONMENTS.PRODUCTION;
        case ENVIRONMENTS.STAGING:
            return ENVIRONMENTS.STAGING;
        default:
            return ENVIRONMENTS.DEVELOPMENT;
    }
};
